import { useQuery } from '@tanstack/react-query'
import { facebookService } from '@/services/facebookService'
import { queryKeys } from '../keys'

interface UseFacebookStatusQueryOptions {
  enabled?: boolean
}

export function useFacebookStatusQuery(options: UseFacebookStatusQueryOptions = {}) {
  return useQuery({
    queryKey: queryKeys.meta.facebookStatus(),
    queryFn: async () => facebookService.getFacebookStatus(),
    enabled: options.enabled ?? true,
  })
}